import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18baadd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "movie-modal"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "trailer-container"
}
const _hoisted_4 = { class: "video-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "movie-info" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "overview" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "info-list" }
const _hoisted_11 = { class: "badge" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data de Lançamento: ", -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-imdb" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "loading"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cog fa-spin" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movie_rating = _resolveComponent("movie-rating")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "overlay",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.overlayClicked && _ctx.overlayClicked(...args)), ["self"]))
          }, [
            (_ctx.movie)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: _ctx.imgUrl(_ctx.movie.backdrop_path),
                    alt: _ctx.movie.title
                  }, null, 8, _hoisted_2),
                  _createElementVNode("i", {
                    class: "fa-regular fa-circle-xmark",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.overlayClicked && _ctx.overlayClicked(...args)))
                  }),
                  (_ctx.movie.videos?.results.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          (_ctx.showTrailer)
                            ? (_openBlock(), _createElementBlock("iframe", {
                                key: 0,
                                frameborder: "0",
                                allowfullscreen: "",
                                allow: "autoplay; modestbranding; encrypted-media",
                                src: _ctx.youtubeUrl(_ctx.movie.videos.results[0].key)
                              }, "\n            ", 8, _hoisted_5))
                            : _createCommentVNode("", true)
                        ]),
                        (!_ctx.showTrailer)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: "fa-regular fa-circle-play",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTrailer && _ctx.openTrailer(...args)))
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.movie.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.movie.tagline), 1),
                    _createVNode(_component_movie_rating, {
                      rating: _ctx.movie.vote_average
                    }, null, 8, ["rating"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.movie.overview), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("ul", _hoisted_10, [
                          _createElementVNode("li", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movie.genres, (genre) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: genre.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {path: '/genre/' + genre.id},
                                  onClick: _ctx.overlayClicked
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(genre.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "onClick"])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_12,
                            _createTextVNode(_toDisplayString(_ctx.dateFormat(_ctx.movie.release_date)), 1)
                          ])
                        ]),
                        (_ctx.movie.imdb_id)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.imdbUrl(_ctx.movie.imdb_id),
                              class: "external-site-logo",
                              target: "_blank"
                            }, _hoisted_15, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}